export default __webpack_public_path__ + "static/media/icon-user.50875cbf.svg";